module.exports = __webpack_public_path__ + "img/marker_three_green1.a151f6b8.png";